import { useInteriorOrganizerStore } from '../../../data/interior-organizer-store';
import { ChangeEvent } from 'react';
import { getFilteredItems } from '../../../domain/storage-items-provider';

const StorageItemsFilters = () => {

    const storageItemsData = useInteriorOrganizerStore(store => store.storageItemsData);

    const filterWidth = useInteriorOrganizerStore(store => store.itemsFilterWidth);
    const setFilterWidth = useInteriorOrganizerStore(store => store.setItemsFilterWidth);

    const filterHeight = useInteriorOrganizerStore(store => store.itemsFilterHeight);
    const setFilterHeight = useInteriorOrganizerStore(store => store.setItemsFilterHeight);

    const filterDepth = useInteriorOrganizerStore(store => store.itemsFilterDepth);
    const setFilterDepth = useInteriorOrganizerStore(store => store.setItemsFilterDepth);

    const filterName = useInteriorOrganizerStore(store => store.itemsFilterName);
    const setFilterName = useInteriorOrganizerStore(store => store.setItemsFilterName);

    const onWidthChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const value = evt.target.value;
        if(isNaN(Number(value))) return;

        const width = Number(value);
        setFilterWidth(width);
    };

    const onHeightChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const value = evt.target.value;
        if(isNaN(Number(value))) return;

        const height = Number(value);
        setFilterHeight(height);
    };

    const onDepthChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const value = evt.target.value;
        if(isNaN(Number(value))) return;

        const depth = Number(value);
        setFilterDepth(depth);
    };

    const onNameChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const value = evt.target.value;
        setFilterName(value);
    };

    const itemsLength = getFilteredItems(
        storageItemsData,
        filterWidth,
        filterHeight,
        filterDepth,
        filterName,
    )?.length ?? 0;

    return (
        <div className="text-sm mt-2 mb-4">
            <div className="grid md:grid-cols-4 gap-4 mb-2">
                <label className="flex flex-col">
                    <span className="font-bold text-slate-400 mb-2">Width</span>
                    <input
                        value={ filterWidth }
                        onInput={ onWidthChange }
                        className={ `border rounded px-4 py-2` }
                        type="text"
                    />
                </label>

                <label className="flex flex-col">
                    <span className="font-bold text-slate-400 mb-2">Height</span>
                    <input
                        value={ filterHeight }
                        onInput={ onHeightChange }
                        className={ `border rounded px-4 py-2` }
                        type="text"
                    />
                </label>

                <label className="flex flex-col">
                    <span className="font-bold text-slate-400 mb-2">Depth</span>
                    <input
                        value={ filterDepth }
                        onInput={ onDepthChange }
                        className={ `border rounded px-4 py-2` }
                        type="text"
                    />
                </label>

                <label className="flex flex-col">
                    <span className="font-bold text-slate-400 mb-2">Name</span>
                    <input
                        value={ filterName }
                        onInput={ onNameChange }
                        className={ `border rounded px-4 py-2` }
                        type="text"
                    />
                </label>
            </div>
            <div className="text-right">{ itemsLength } Items</div>
        </div>
    )
};

export default StorageItemsFilters;